export default __webpack_public_path__ + "static/media/plus-icon.51073b7f.svg";